export default {
  COURSES: 'courses',
  TRAININGS: 'trainings',
  E_DIRECT: 'direct',
  E_CARRIER: 'carrier',
  FULLTRAININGS: 'fulltrainings',
}
